<script src="../../../Services/Files/image.service.ts"></script>
<section class="breadcrumb-section-main inner-2 breadcrumb-section-sm">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="breadcrumb-contain ">
                    <div>
                        <h2 class="breadcrumb-txt">Tabelle Konfigurieren</h2>
                    </div>
                    <div>
                        <ul>
                            <li><a href="#">Tabellen</a></li>
                            <li><a href="#"><i class="fa fa-angle-double-right"></i>Tabelle generieren</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<section id="how-work" class="saas1 howitwork" [ngStyle]="{'background-image': 'url(assets/images/saas1/work-bg.png)'}">
    <div class="container">
        <div class="row">
            <div class="col-md-12 text-center">
                <div class="title">
                    <img src="../../../../assets/images/saas1/title-logo.png" alt="title-logo" class="img-fluid">
                    <div class="main-title">
                        <h2>
                            Tabelle Konfigurieren
                        </h2>
                    </div>
                    <hr>
                    <div class="sub-title">
                        <p class="p-padding">In unserem interaktiven Step-by-Step-Guide erstellen und konfigurieren Sie
                            Ihre persönliche Lead-Tabelle. Durchlaufen Sie jeden Schritt und passen Sie die Tabelle
                            exakt an Ihre Bedürfnisse an – schnell, intuitiv und effizient.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<section>
    <div class="container">
        <div class="row p-0 mb-4 rounded-3 mt-4 shadow-sm border">
            <!-- Stepper Panel -->
            <div class="col-lg-9 col-md-8 col-12 ">
                <div class="stepper-container">
                    <mat-stepper #stepper="matStepper" [linear]="isLinear"
                                 (selectedIndexChange)="onIndexChange($event)">
                        <!-- 1. Branche auswählen -->
                        <mat-step [stepControl]="branchFormGroup">
                            <form [formGroup]="branchFormGroup">
                                <ng-template matStepLabel>Branche</ng-template>
                                <h3 class="mb-2 mt-2 p-2">Branche auswählen</h3>
                                <div class="row justify-content-center">
                                    <div class="col-10">
                                        <p class="mb-3 text-muted">
                                            Wählen Sie die Branche aus, für die Sie Unternehmensdaten erhalten möchten.
                                            Nutzen Sie das Suchfeld, um die passende Branche schnell zu finden.
                                        </p>

                                        <!-- Existing dropdown/search field -->
                                        <mat-form-field appearance="fill" class="search-form-field rounded-10">
                                            <mat-label>Branche auswählen</mat-label>
                                            <mat-icon matPrefix>search</mat-icon>
                                            <input
                                                    type="text"
                                                    matInput
                                                    formControlName="branchCtrl"
                                                    [matAutocomplete]="auto"
                                            >
                                            <mat-autocomplete panelClass="rounded-autocomplete"
                                                              #auto="matAutocomplete"
                                                              [displayWith]="displayFn.bind(this)"
                                                              (optionSelected)="onBranchSelected($event)"
                                            >
                                                <mat-option
                                                        *ngFor="let option of filteredIndustries | async"
                                                        [value]="option"
                                                >
                                                    {{ option.name }}
                                                </mat-option>
                                            </mat-autocomplete>

                                        </mat-form-field>

                                        <!-- Info Box -->
                                        <div class="alert alert-info d-flex align-items-center py-2 px-3 mb-3 mt-auto"
                                             style="background: #f1f8ff;">
                                            <mat-icon class="me-2" style="font-size: 22px; color: #1976d2;">info
                                            </mat-icon>
                                            <span>
                                                Die <strong>Branche</strong> bestimmt, aus welchem Bereich die Unternehmen stammen,
                                                z.&nbsp;B. Gesundheit, Bildung, Finanzen, Handel u.&nbsp;v.&nbsp;m.<br>
                                                Sie können nur eine Branche gleichzeitig auswählen.
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </mat-step>

                        <!-- Regionen Step -->
                        <mat-step [stepControl]="regionFormGroup">
                            <form [formGroup]="regionFormGroup">
                                <ng-template matStepLabel>Regionen</ng-template>
                                <h3 class="mb-2 mt-2">Regionen auswählen</h3>
                                <div class="row justify-content-center">
                                    <div class="col-12 col-md-10">
                                        <p class="mb-3 text-muted fs-6">
                                            Wählen Sie eine oder mehrere Regionen (Bundesländer), aus denen Sie
                                            Unternehmensdaten erhalten möchten.
                                        </p>
                                        <div formArrayName="states">

                                            <!-- Deutschlandweit als eigene Zeile -->
                                            <ng-container *ngIf="states.length > 0">
                                                <div
                                                        *ngIf="states[0]?.label === 'Deutschlandweit'"
                                                        class="d-flex align-items-center gap-3 mb-3 p-3 rounded-3 bg-light border border-1 shadow-sm"
                                                        style="cursor: pointer;"
                                                        (click)="toggleStateArray(statesArray, 0)"
                                                >
                                                    <mat-checkbox
                                                            class="me-2"
                                                            [formControlName]="0"
                                                            (click)="$event.stopPropagation()"
                                                    ></mat-checkbox>
                                                    <span class="fw-semibold flex-grow-1">{{ states[0].label }}</span>
                                                    <span class="text-secondary small">{{ states[0].count | number }}
                                                        Zeilen</span>
                                                </div>
                                            </ng-container>
                                            <mat-divider></mat-divider>

                                            <!-- Restliche Regionen: 2 Spalten -->
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <ng-container
                                                            *ngFor="let state of states.slice(1, Math.ceil((states.length-1)/2) + 1); let i = index">
                                                        <div
                                                                class="d-flex align-items-center gap-3 mb-2 p-2 rounded-3 bg-light border border-1 shadow-sm"
                                                                style="cursor: pointer;"
                                                                (click)="toggleStateArray(statesArray, i + 1)"
                                                        >
                                                            <mat-checkbox
                                                                    class="me-2"
                                                                    [formControlName]="i + 1"
                                                                    (click)="$event.stopPropagation()"
                                                            ></mat-checkbox>
                                                            <span class="flex-grow-1">{{ state.label }}</span>
                                                            <span class="text-secondary small">{{ state.count | number }}
                                                                Zeilen</span>
                                                        </div>
                                                    </ng-container>
                                                </div>
                                                <div class="col-md-6">
                                                    <ng-container
                                                            *ngFor="let state of states.slice(Math.ceil((states.length-1)/2) + 1); let i = index">
                                                        <div
                                                                class="d-flex align-items-center gap-3 mb-2 p-2 rounded-3 bg-light border border-1 shadow-sm"
                                                                style="cursor: pointer;"
                                                                (click)="toggleStateArray(statesArray, i + 1 + Math.ceil((states.length-1)/2))"
                                                        >
                                                            <mat-checkbox
                                                                    class="me-2"
                                                                    [formControlName]="i + 1 + Math.ceil((states.length-1)/2)"
                                                                    (click)="$event.stopPropagation()"
                                                            ></mat-checkbox>
                                                            <span class="flex-grow-1">{{ state.label }}</span>
                                                            <span class="text-secondary small">{{ state.count | number }}
                                                                Zeilen</span>
                                                        </div>
                                                    </ng-container>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Validierungs-Fehler -->
                                <div *ngIf="regionFormGroup.get('states').invalid && (regionFormGroup.get('states').touched || regionFormGroup.get('states').dirty)"
                                     class="text-danger mt-3">
                                    Bitte wählen Sie mindestens eine Region aus.
                                </div>
                                <div *ngIf="(regionFormGroup.get('minimum')?.touched || regionFormGroup.get('minimum')?.dirty)"
                                     class="text-danger mt-3">
                                    Bitte wählen Sie mindestens 1000 Zeilen Aus
                                </div>

                                <!-- Info- und Alert-Box mit Abstand nach oben -->
                                <div class="mt-5"></div>
                                <div class="alert alert-info d-flex align-items-center py-3 px-4 shadow-sm"
                                     style="background: #f1f8ff;">
                                    <mat-icon class="me-2" style="font-size: 22px; color: #1976d2;">info</mat-icon>
                                    <span class="fs-6">
                                    Sie können beliebig viele Bundesländer auswählen. <br>
                                    Mit der Option <strong>„Deutschlandweit“</strong> (oben) wählen Sie alle Regionen gleichzeitig aus.
                                    <br>Mindestens eine Auswahl ist erforderlich.
                                  </span>
                                </div>
                            </form>
                        </mat-step>

                        <!-- Unternehmens Infos Step -->
                        <mat-step [stepControl]="companyInfosGroup">
                            <form [formGroup]="companyInfosGroup">
                                <ng-template matStepLabel>Unternehmens Infos</ng-template>
                                <h3 class="mb-2 mt-2">Unternehmes Infos</h3>
                                <div class="row justify-content-center">
                                    <div class="col-10">
                                        <p class="mb-3 text-muted">
                                            Wählen Sie die gewünschten Firmen Infos aus.
                                        </p>
                                        <div formArrayName="companyInfos">


                                            <!-- Basis-Informationen -->
                                            <h5 class="mt-3 mb-2">Basis-Informationen</h5>
                                            <div
                                                    *ngFor="let company of basicInfos; let i = index"
                                                    class="company-row mb-1 p-1 rounded-3 bg-light border border-1 shadow-sm d-flex align-items-center"
                                                    style="cursor: pointer;"
                                                    (click)="toggleCompanyInfo(companyInfosArray, i)"
                                            >
                                                <mat-checkbox
                                                        class="me-2 flex-shrink-0"
                                                        [formControlName]="i"
                                                        (click)="$event.stopPropagation()"
                                                ></mat-checkbox>
                                                <span class="company-label flex-grow-1 text-truncate">{{ company.label }}</span>
                                                <button
                                                        mat-icon-button
                                                        type="button"
                                                        class="help-btn"
                                                        (click)="openHelpModal(helpModal, company.label)"
                                                        aria-label="Mehr Informationen"
                                                >
                                                    <mat-icon fontIcon="help_outline"></mat-icon>
                                                </button>
                                                <span class="company-count d-flex align-items-center flex-shrink-0">
                                                    <span class="company-number text-end">{{ company.count }}</span>
                                                    <span class="company-zeilen ms-1">Zeilen</span>
                                                </span>
                                            </div>

                                            <!-- Kontaktinformationen -->
                                            <h5 class="mt-4 mb-2">Kontaktinformationen</h5>
                                            <div
                                                    *ngFor="let company of contactInfos; let i = index"
                                                    class="company-row mb-1 p-1 rounded-3 bg-light border border-1 shadow-sm d-flex align-items-center"
                                                    style="cursor: pointer;"
                                                    (click)="toggleCompanyInfo(companyInfosArray, i + basicInfos.length)"
                                            >
                                                <mat-checkbox
                                                        class="me-2 flex-shrink-0"
                                                        [formControlName]="i + basicInfos.length"
                                                        (click)="$event.stopPropagation()"
                                                ></mat-checkbox>
                                                <span class="company-label flex-grow-1 text-truncate">{{ company.label }}</span>
                                                <button
                                                        mat-icon-button
                                                        type="button"
                                                        class="help-btn"
                                                        (click)="openHelpModal(helpModal, company.label)"

                                                        aria-label="Mehr Informationen"
                                                >
                                                    <mat-icon fontIcon="help_outline"></mat-icon>
                                                </button>
                                                <span class="company-count d-flex align-items-center flex-shrink-0">
                                                    <span class="company-number text-end">{{ company.count }}</span>
                                                    <span class="company-zeilen ms-1">Zeilen</span>
                                                </span>
                                            </div>

                                            <!-- Weitere Informationen -->
                                            <h5 class="mt-4 mb-2">Weitere Informationen</h5>
                                            <div
                                                    *ngFor="let company of additionalInfos; let i = index"
                                                    class="company-row mb-1 p-1 rounded-3 bg-light border border-1 shadow-sm d-flex align-items-center"
                                                    style="cursor: pointer;"
                                                    (click)="toggleCompanyInfo(companyInfosArray, i + basicInfos.length + contactInfos.length)"
                                            >
                                                <mat-checkbox
                                                        class="me-2 flex-shrink-0"
                                                        [formControlName]="i + basicInfos.length + contactInfos.length"
                                                        (click)="$event.stopPropagation()"
                                                ></mat-checkbox>
                                                <span class="company-label flex-grow-1 text-truncate">{{ company.label }}</span>
                                                <button
                                                        mat-icon-button
                                                        type="button"
                                                        class="help-btn"
                                                        (click)="openHelpModal(helpModal, company.label)"

                                                        aria-label="Mehr Informationen"
                                                >
                                                    <mat-icon fontIcon="help_outline"></mat-icon>
                                                </button>
                                                <span class="company-count d-flex align-items-center flex-shrink-0">
                                                    <span class="company-number text-end">{{ company.count }}</span>
                                                    <span class="company-zeilen ms-1">Zeilen</span>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div *ngIf="companyInfosGroup.get('companyInfos').invalid && (companyInfosGroup.get('companyInfos').touched || companyInfosGroup.get('companyInfos').dirty)"
                                     class="text-danger mt-2">
                                    Bitte wählen Sie mindestens ein Unternehmens-Info-Feld aus.
                                </div>
                                <div *ngIf="(companyInfosGroup.get('minimum')?.touched || companyInfosGroup.get('minimum')?.dirty)"
                                     class="text-danger mt-3">
                                    Bitte wählen Sie mindestens 1000 Zeilen Aus
                                </div>

                            </form>

                        </mat-step>

                        <!-- 4. Anzahl -->
                        <mat-step [stepControl]="quantityFormGroup">
                            <form [formGroup]="quantityFormGroup" class="w-100">
                                <ng-template matStepLabel>Anzahl</ng-template>
                                <h3 class="mb-2 mt-2">Anzahl der Firmendatensätze wählen</h3>
                                <div class="row justify-content-center">
                                    <div class="col-12 col-md-10">
                                        <p class="mb-3 text-muted fs-6">
                                            Hier können Sie die <strong>maximale Anzahl an Firmendatensätzen</strong>
                                            festlegen, die Sie aus unserer Datenbank erhalten möchten.
                                            Nutzen Sie den Schieberegler, um die für Sie passende Menge auszuwählen und
                                            Ihr individuelles Limit zu bestimmen.
                                        </p>

                                        <div class="row align-items-center justify-content-center mb-2">
                                            <div class="col-12">
                                                <mat-slider
                                                        [min]="sliderMin"
                                                        [max]="forgedSliderMax"
                                                        [step]="sliderStep"
                                                        thumbLabel
                                                        tickInterval="500"
                                                        [displayWith]="sliderDisplayWith"
                                                        (input)="onQuantityChange()"
                                                        color="primary"
                                                        class="w-100 mt-3">
                                                    <input matSliderThumb formControlName="quantity">
                                                </mat-slider>
                                                <div class="d-flex justify-content-between mt-2">
                                                    <span class="form-label small text-secondary">{{ sliderMin | number }}
                                                        (Minimum)</span>
                                                    <span class="form-label small text-secondary">{{ stateConfig.availableRowCount | number }}
                                                        (Alle verfügbaren Datensätze)</span>
                                                </div>
                                                <div class="alert alert-light mt-3 py-2 mb-1 d-flex align-items-center gap-2"
                                                     style="font-size:1.07rem;">
                                                    <i class="bi bi-check-circle-fill text-success"
                                                       style="font-size:1.3rem;"></i>
                                                    <span>
                                                    <strong>Ihre Auswahl:</strong>
                                                    <span class="fw-bold">{{ stateConfig.selectedQuantity$ | async | number }}</span> Firmendatensätze
                                                  </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </mat-step>

                        <!-- Final -->
                        <mat-step>
                            <ng-template matStepLabel>Bestellen</ng-template>
                            <h3 class="mb-2 mt-2">Ihre Bestellung zusammenfassen</h3>
                            <div class="row justify-content-center">
                                <div class="col-12 col-md-10">
                                    <p class="mb-4 text-muted">
                                        Überprüfen Sie Ihre Auswahl, bevor Sie fortfahren.
                                    </p>

                                    <div class="card mb-4 shadow-sm">
                                        <div class="card-header bg-light">
                                            <h5 class="mb-0">Bestellübersicht</h5>
                                        </div>
                                        <div class="card-body">
                                            <p class="d-flex justify-content-between">
                                                <span>Ausgewählte Branche:</span>
                                                <strong>{{ stateConfig.selectedTableDisplayName || 'Nicht ausgewählt' }}</strong>
                                            </p>
                                            <div class="mb-2">
                                                <span>Ausgewählte Regionen:</span>
                                                <ul class="list-unstyled ms-3 mt-1">
                                                    <li *ngFor="let region of stateConfig.selectedStates">
                                                        <strong>- {{ region }}</strong>
                                                    </li>
                                                    <li *ngIf="!stateConfig.selectedStates || stateConfig.selectedStates.length === 0">
                                                        <strong>Nicht ausgewählt</strong>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div class="mb-2">
                                                <span>Ausgewählte Unternehmensinfos:</span>
                                                <ul class="list-unstyled ms-3 mt-1">
                                                    <li *ngFor="let info of stateConfig.selectedCompanyInfos">
                                                        <strong>- {{ info }}</strong>
                                                    </li>
                                                    <li *ngIf="!stateConfig.selectedCompanyInfos || stateConfig.selectedCompanyInfos.length === 0">
                                                        <strong>Nicht ausgewählt</strong>
                                                    </li>
                                                </ul>
                                            </div>
                                            <p class="d-flex justify-content-between">
                                                <span>Anzahl Datensätze:</span>
                                                <strong>{{ stateConfig.selectedQuantity | number }}</strong>
                                            </p>
                                            <hr>
                                            <h4 class="d-flex justify-content-between text-primary">
                                                <span>Preis:</span>
                                                <strong>{{ stateConfig.selectedPrice | currency:'EUR':'symbol':'1.2-2' }}</strong>
                                            </h4>
                                        </div>
                                    </div>

                                    <p class="mb-3 text-muted">
                                        Klicken Sie auf den Button <strong>"Jetzt bestellen!"</strong>, um zur finalen
                                        Bestellseite weitergeleitet zu werden.
                                        Dort können Sie Ihre Bestellung abschließen und die Zahlung vornehmen.
                                    </p>

                                    <div class="d-grid gap-2">
                                        <button mat-raised-button color="primary" class="py-3 fs-5"
                                                (click)="navigateToOrderPage()">
                                            <mat-icon>arrow_forward</mat-icon>
                                            Jetzt bestellen!
                                        </button>
                                    </div>

                                    <p class="mt-4 small text-muted text-center">
                                        Bei Fragen oder Problemen kontaktieren Sie bitte unseren <a href="/kontakt">Support</a>.
                                    </p>
                                </div>
                            </div>
                        </mat-step>

                    </mat-stepper>
                </div>
            </div>

            <!-- Overview Panel -->
            <div class="col-lg-3 col-md-4 col-12 mb-4">
                <div>
                    <div class="card-body py-4 px-4">
                        <h5 class="mb-4 d-flex align-items-center text-black fw-bold">
                            <mat-icon class="me-2">dashboard_customize</mat-icon>
                            Ihre Auswahl
                        </h5>

                        <div class="mb-4">
                            <span class="text-muted fw-semibold">Branche:</span>
                            <div class="ps-3 mt-1">
                                <span *ngIf="stateConfig.selectedTableDisplayName; else none">{{ stateConfig.selectedTableDisplayName }}</span>
                                <ng-template #none><span class="text-muted">Keine Auswahl</span></ng-template>
                            </div>
                        </div>

                        <div class="mb-4">
                            <span class="text-muted fw-semibold">Regionen:</span>
                            <div class="ps-3 mt-1 d-flex flex-wrap gap-2">
                                <ng-container
                                        *ngIf="stateConfig.selectedStates && stateConfig.selectedStates.length > 0; else noRegions">
                                    <ng-container
                                            *ngIf="stateConfig.selectedStates.includes('Deutschlandweit'); else showAllRegions">
                                        <span class="badge bg-light text-dark-emphasis border border-1 x-3 py-2 rounded-pill">Deutschlandweit</span>
                                    </ng-container>
                                    <ng-template #showAllRegions>
                                        <span *ngFor="let region of stateConfig.selectedStates"
                                              class="badge bg-light text-dark-emphasis border border-1 x-3 py-2 rounded-pill">{{ region }}</span>
                                    </ng-template>
                                </ng-container>
                                <ng-template #noRegions><span class="text-muted">Keine</span></ng-template>
                            </div>
                        </div>

                        <div class="mb-4">
                            <span class="text-muted fw-semibold">Firmen-Infos:</span>
                            <div class="ps-3 mt-1 d-flex flex-wrap gap-2">
                                <ng-container
                                        *ngIf="stateConfig.selectedCompanyInfos && stateConfig.selectedCompanyInfos.length > 0; else noInfos">
                                    <span *ngFor="let info of stateConfig.selectedCompanyInfos"
                                          class="badge bg-light text-dark-emphasis border border-1 x-3 py-2 rounded-pill">{{ info }}</span>
                                </ng-container>
                                <ng-template #noInfos><span class="text-muted">Keine</span></ng-template>
                            </div>
                        </div>

                        <div class="mb-2 d-flex flex-column gap-1">
                            <!-- Row Number Card -->
                            <div class="info-metric-card d-flex align-items-center gap-1 px-1 py-1 rounded-4 bg-gradient-blue">

                                <div>
                                    <div class="metric-label text-uppercase fw-bold text-primary mb-0"
                                         style="font-size: 0.48rem; letter-spacing: .07em;">Zeilenanzahl
                                    </div>
                                    <div class="metric-value fw-semibold text-dark mb-0">
                                        <ng-container
                                                *ngIf="stateConfig.selectedQuantity && stateConfig.selectedQuantity != 0; else noRowCount">
                                            {{ stateConfig.selectedQuantity | number }}
                                        </ng-container>
                                        <ng-template #noRowCount>--</ng-template>
                                    </div>
                                </div>
                            </div>

                            <!-- Price Card -->
                            <div class="info-metric-card d-flex align-items-center gap-1 px-1 py-1 rounded-4 bg-gradient-green">
                                <div>
                                    <div class="metric-label text-uppercase fw-bold text-success mb-0"
                                         style="font-size: 0.48rem; letter-spacing: .07em;">Preis
                                    </div>
                                    <div class="metric-value fw-semibold text-dark mb-0">
                                        <ng-container
                                                *ngIf="stateConfig.selectedPrice != null && stateConfig.selectedPrice != 0; else noPrice">
                                            {{ stateConfig.selectedPrice | number:'1.2-2' }}&nbsp;€
                                        </ng-container>
                                        <ng-template #noPrice>--</ng-template>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <!-- Navigation -->
            <div class="stepper-navigation">
                <button class="btn-lg rounded-5 me-2 border border-1 btn-outline-blue"
                        mat-button
                        (click)="stepper.previous()"
                        [disabled]="stepper.selectedIndex === 0">
                    Back
                </button>
                <button class="btn-lg rounded-5 btn-outline-blue"
                        mat-button
                        (click)="goToNextStep(stepper)">
                    Next
                </button>
            </div>

        </div>
        <div class="row">
            <div class="mb-5"></div>
            <app-listpreview></app-listpreview>
        </div>
    </div>
    <div class="mb-5"></div>
</section>


<!-- Modal Template -->
<ng-template #helpModal let-modal>
    <div class="modal-header">
        <h4 class="modal-title">{{ selectedColumnExplanation?.title }}</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body">
        <p class="text-muted">{{ selectedColumnExplanation?.shortDescription }}</p>
        <p>{{ selectedColumnExplanation?.longDescription }}</p>
    </div>
</ng-template>